import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import { getColor } from '../../../utils/ColorUtil'
import { i18nize } from '../../../utils/StringUtil'
import { EVENT_TYPES } from '../../constants/EventsConstants'
import { Box, Grid } from '@mui/material'

const EventsTypeLegendPanel = ({ eventsTypes }) => {
    return (
        <Grid container size={12} spacing={0.5}>
            {
                (eventsTypes || i18nize(EVENT_TYPES)).concat([{ label: i18n.unknownType, color: 'GREY' }]).map((eventType, i) => (
                    <Grid key={i} container size={6} spacing={1} alignItems={'center'}>
                        <Grid container size={12} wrap='nowrap' alignItems='center' columnSpacing={1}>
                            <Box
                                sx={{
                                    flex: 'none',
                                    width: 30,
                                    height: 18,
                                    borderRadius: 10,
                                    backgroundColor: getColor(eventType.color),
                                }}
                            />
                            <Grid size='grow' sx={{ minWidth: 0 }}>{ eventType.label }</Grid>
                        </Grid>
                    </Grid>
                ))
            }
        </Grid>
    )
}

EventsTypeLegendPanel.propTypes = {
    eventsTypes: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
        id: PropTypes.number,
        label: PropTypes.string,
        color: PropTypes.string,
        icon: PropTypes.string,
    })),
}

export default EventsTypeLegendPanel
